import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SearchItem } from 'src/app/models/searchItem';
import { Shortcuts } from 'src/app/models/Shortcuts';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SearchService } from 'src/app/services/search.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ShortcutsModalControlService } from '../configurations/services/shortcuts-modal-control.service';

@Component({
  selector: 'app-shortcuts-management',
  templateUrl: './shortcuts-management.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ShortcutsManagementComponent implements OnInit {

  selectedShortcuts : SearchItem[] = [];
  shortcuts : SearchItem[] = [];

  constructor(private bsModalRef : BsModalRef,
    public shortcutsService : ShortcutsModalControlService,
    private searchService : SearchService,
    private utilsService : UtilsService,
    private modalService : ModalControlService) { }

  ngOnInit(): void {
    this.loadShorcuts();
  }

  loadShorcuts() : void {
    this.searchService.unselectAllSearchItems();
    this.shortcutsService.getAllShorcuts().subscribe( results =>{
      results.forEach( shortcut => {
        let shortcutItem : Shortcuts = shortcut;
        let searchItem = this.searchService.getItemByShortcut(shortcutItem);
        this.selectedShortcuts.push(searchItem);
      });
      this.searchService.searchItems.forEach( item => {
        if (this.utilsService.containsObject(item, this.selectedShortcuts)){
          item.selected = true;
        }
        this.shortcuts.push(item);
      });
      this.shortcuts.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
    })
    });
  }

  addShortcut(shortcut : SearchItem) {
    let newShortcut = new Shortcuts();
    newShortcut.sAction = shortcut.name;
    newShortcut.sOrder = 1;

  }

  selectItem(item : SearchItem) : void {
    item.selected = !item.selected;
  }

  save() : void {
    let shortcutsToSave : Shortcuts[] = [];
    let shortcutsToUpdate : SearchItem[] = [];

    this.shortcuts.forEach( short => {
      if (short.selected) {
        let newShortcut : Shortcuts = new Shortcuts();
        newShortcut.sAction = short.name;
        newShortcut.sOrder = 1;
        shortcutsToSave.push(newShortcut);
        if (!this.utilsService.containsObject(short, this.selectedShortcuts))
          this.selectedShortcuts.push(short);
      } else {
        const removeIndex = this.selectedShortcuts.findIndex( item => item === short );
        // remove object
        if (removeIndex != -1){
          this.selectedShortcuts.splice( removeIndex, 1 );
          this.shortcutsService.deleteShortcut(short.shortcutId);
        }
      }
    });

    if (this.selectedShortcuts.length <= 5) {
      this.shortcutsService.shortcuts = this.selectedShortcuts;
      this.shortcutsService.insertShortcutsBulk(shortcutsToSave);
    } else {
      this.modalService.showMesssageModal("Maximum Number of Shortcuts Exceded", "You can only define 5 shortcuts");
    }
    this.bsModalRef.hide();
  }

  cancel(){
    this.bsModalRef.hide();
  }

}
